module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "#/"
    }
  }, [_c('img', {
    staticClass: "logo-salutance",
    attrs: {
      "src": "/static/img/salutance/logo-salutance-3.png"
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "header",
    attrs: {
      "xs12": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-card-text', [_vm._v("\n            Grâce au programme SALUTANCE 5.0 vous serez accompagné(e), pendant 1 an,\n            par des professionnels de santé qualifiés : diététicien(ne)s, psychologues, tabacologues, enseignant(e) en activité\n            physique adaptée. Et tout cela, près de chez vous ! L’union fait la forme\n         ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/salutance/runner.jpg",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Objectifs :")]), _vm._v(" "), _c('div', [_vm._v("Se faire aider pour être en forme et en bonne santé\n               ")])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/salutance/cooking.png",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("En pratique !")]), _vm._v(" "), _c('div', [_vm._v("Une année pour changer de quotidien\n               ")])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/salutance/tablet.png",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Actus")]), _vm._v(" "), _c('div', [_vm._v("À compléter\n               ")])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/salutance/smile.jpg",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("L'équipe")]), _vm._v(" "), _c('div', [_vm._v("Un accompagnement de qualité\n               ")])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/salutance/europe.jpg",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Les villes concernées :")]), _vm._v(" "), _c('div', [_vm._v("Une aide de proximité\n               ")])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard",
    attrs: {
      "to": "/salutance-screening"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/salutance/velo.png",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Comment participer ?")]), _vm._v(" "), _c('div', [_vm._v("Vous avez entre 40 et 55 ans, "), _c('span', {
    staticStyle: {
      "color": "orange"
    },
    attrs: {
      "to": "/salutance-screening"
    }
  }, [_vm._v("rejoignez nous !")])])])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-312f0258","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/salutance/SalutanceNews.vue
// module id = 1180
// module chunks = 1